import { ShiftDifferentialType } from '~/types/hlx/enums';
import { MsaasJobListing } from '~/types/hlx/msaasJobListing';
import { emptyShiftDetailsForm, SHIFT_DIFF_TYPE_OPTIONS } from './constants';
import { ShiftDetailsFormValues } from './types';

export const transformApiToShiftDetailsForm = (
  msaasListing: MsaasJobListing
): ShiftDetailsFormValues => {
  const shiftDiffTypeValue =
    msaasListing.detail?.shiftDiffType || ShiftDifferentialType.INCR_HOURLY_RATE;
  const shiftDiffTypeOption =
    SHIFT_DIFF_TYPE_OPTIONS.find((option) => option.value === shiftDiffTypeValue) ||
    SHIFT_DIFF_TYPE_OPTIONS[0];

  return {
    ...emptyShiftDetailsForm,
    ...msaasListing.detail,
    id: msaasListing.detail?.id,
    msaasListingId: msaasListing.id,
    shiftDiffType: shiftDiffTypeOption,
  };
};

export const transformShiftDetailsFormToApi = (formValues: ShiftDetailsFormValues) => {
  return JSON.stringify({
    ...formValues,
    shiftDiffType: formValues.shiftDiffType.value,
  });
};
